@if (showFilter()) {
  <div class="mt-10 currency-filter-wrapper">
    @for (filter of currencyFilters; track filter) {
      <button
        class="filter-button button-currency-filter"
        (click)="select(filter.value)"
			[ngClass]="{
				selected: filterType === filter.value,
				'btn-white': !isWalletDashboard
			}">
        {{ filter.name | translate }}
      </button>
    }
  </div>
}
@if (showNoResults) {
  <no-results-found></no-results-found>
}
